module.exports = __webpack_public_path__ + "static/img/contract12.a0e8e09.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/contract12.png
// module id = 903
// module chunks = 1